{
    "TermsAndConditions_Title": "Termos e Condições",
    "TermsAndConditions_Subtitle": "Os termos e condições de utilização da aplicação são apresentados abaixo. Por favor, indique que os aceita, selecionando \"Aceito os termos e condições de serviço\" e clicando também no botão \"Aceitar\".",
    "TermsAndConditions_Subtitle_NoAccept": "Os nossos termos e condições de serviço padrão são apresentados abaixo.",
    "TermsAndConditions_AcceptText": "Eu concordo com os termos e condições",
    "TermsAndConditions_AcceptButton": "Aceitar",
    "TermsAndConditions_CloseButton": "Fechar",
    "NAME": "TermsAndConditions"
}